<template>
  <div class="crafting-queue-time-limit-tooltip" :class="{ 'ru-locale': $i18n.locale === 'ru' }">
    <div>
      <span>{{ $t('craftingQueueLimitContentMessageText1') }}</span>
      <span class="popper-highlighted-text">{{ $t('craftingQueueLimitContentMessageText2') }}</span>
      <span>{{ $t('craftingQueueLimitContentMessageText3') }}</span>
      <span class="skeleton">
        <el-skeleton :loading="maxQueuePerUserData.isLoading.value" animated style="width: 60px; max-width: 60px">
          <template #template>
            <el-skeleton-item style="width: 60px; height: 20px" />
          </template>
          <template #default>
            <span
              :class="{
                'available-amount': maxAmountAvailableForCraft > 0,
                'available-amount-zero': maxAmountAvailableForCraft <= 0
              }"
              >{{ maxAmountAvailableForCraft }}</span
            ><span>/</span><span class="max-queue-amount">{{ maxQueuePerUserData.maxQueuePerUser }}</span
            >.
          </template>
        </el-skeleton></span
      >
    </div>
    <br />
    <div v-if="currentRecipe?.queueType === 0">
      <span>{{ $t('craftingQueueLimitContentMessageText4') }}</span>
      <span class="popper-highlighted-text">{{ $t('craftingQueueLimitContentMessageText5') }}</span>
      <span>{{ $t('craftingQueueLimitContentMessageText6') }}</span>
      <span class="skeleton">
        <el-skeleton :loading="maxQueuePerUserData.isLoading.value" animated style="width: 60px; max-width: 60px">
          <template #template>
            <el-skeleton-item style="width: 60px; height: 20px" />
          </template>
          <template #default>
            <span
              :class="{
                'available-amount': maxAvailableRecipesInMaxQueue > 0,
                'available-amount-zero': maxAvailableRecipesInMaxQueue <= 0
              }"
              >{{ maxAvailableRecipesInMaxQueue }}</span
            ><span>/</span><span class="max-queue-amount">{{ currentRecipe?.maxQueue }}</span
            >.
          </template>
        </el-skeleton></span
      >
    </div>
    <br />
    <p v-html="$t('craftingQueueLimitContentMessageText7')" />
  </div>
</template>
<script lang="ts" setup>
import type { BuildingProps, RecipeProps } from '~/types/crafting';

const building = inject<Ref<BuildingProps>>('building');
const currentRecipe = inject<Ref<RecipeProps>>('currentRecipe');
const maxAvailableRecipesInMaxQueue = inject<Ref<number>>('maxAvailableRecipesInMaxQueue', ref(0));
const maxAmountAvailableForCraft = inject<Ref<number>>('maxAmountAvailableForCraft', ref(0));

const { data: recipeToCraft } = useNuxtData<RecipeProps>('recipes/recipe');
const maxQueuePerUserData = await useMaxQueuePerUser(recipeToCraft, building);
</script>

<style lang="scss" scoped>
.skeleton {
  margin-left: 5px;
  display: inline-flex;
  align-items: center;
  max-height: 20px;

  @media (max-width: 376px) {
    margin-top: 5px;
  }
}

.available-amount {
  font-weight: 700;
  font-size: 20px;
  color: #49ddaa;
}

.available-amount-zero {
  font-weight: 700;
  font-size: 20px;
  color: #f6164c;
}

.max-queue-amount {
  font-weight: 400;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
}
</style>
<style lang="scss">
.crafting-queue-time-limit-tooltip {
  p span {
    color: var(--blue_highlight);
  }
}
</style>
